import { StatePropertyRef } from '../../canvas/ExtendableStore';

export type PropertyStripMode = 'auto' | 'field' | 'disabled';
export interface PropertyStripInfo {
    mode: PropertyStripMode;
}

export const CreatePropertyStripInfo = (mode: PropertyStripMode) => ({ mode }) as PropertyStripInfo;
export const PropertyStripInfo = StatePropertyRef<PropertyStripInfo>('propertyStrip', CreatePropertyStripInfo('auto'));
